import { PurchaseOrder } from './../models/PurchaseOrder.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/wrappers/HttpClient';
import { UrlBuilder } from '../models/utils/url-builder.model';

import * as _ from 'lodash';
import * as bluebird from 'bluebird';

@Injectable()
export class PurchaseOrderService {

    constructor(private httpClient: HttpClient) { }

    endPoint: String = "/purchase-orders";

    async search(purchaseSearch): Promise<PurchaseOrder[]> {

        const builder = new UrlBuilder([
            { key: "skip", value: purchaseSearch.skip },
            { key: "limit", value: purchaseSearch.limit }
        ]);

        var keyValueParams = [];

        keyValueParams = keyValueParams.concat([
            { key: "year", value: purchaseSearch.year }
        ]);

        for (let month of purchaseSearch.months)
            keyValueParams.push({ key: "month", value: month });
        
        for (let group of purchaseSearch.groups)
            keyValueParams.push({ key: "companyGroup", value: group });

        if (purchaseSearch.isBlanketAgreement !== undefined) {
            keyValueParams.push({key: "isBlanketAgreement", value: purchaseSearch.isBlanketAgreement})
        }
        
        if (purchaseSearch.filterAnticipation !== undefined) {
            keyValueParams.push({key: "filterAnticipation", value: purchaseSearch.filterAnticipation})
        }

        const mappingFields = [
            'statusPurchaseOrders',
            'projects',
            'subDivision',
            'companies',
            'customers',
            'approvers',
            'supportCenters',
            'excellenceCenters',
            'industries'
        ];
        mappingFields.forEach((field) => {
            if (purchaseSearch[field] && purchaseSearch[field].length) {
                for (let item of purchaseSearch[field]) {
                    keyValueParams.push({key: field, value: item})
                }
            }
        });

        builder.addQueryStringParamsInsideFilter(keyValueParams);
        let response = await this.httpClient.get(builder.buildUrl(`${this.endPoint}`));
        purchaseSearch.totalItems = response.totalItems;
        return response.purchaseOrders.map(purchase => {
            return new PurchaseOrder(purchase);
        });
    }

    async getById(id): Promise<PurchaseOrder> {
        var purchaseToEdit = new PurchaseOrder();
        var response = await this.httpClient.get(`${this.endPoint}/${id}`);
        purchaseToEdit.loadFromServer(response);
        return purchaseToEdit;
    }

    async create(purchaseOrder: PurchaseOrder) {
        return await this.httpClient.post(this.endPoint, purchaseOrder);
    }

    async createRecurrence(purchaseOrders) {
        purchaseOrders = purchaseOrders.map(po => ({...po, sendEmailToApprover: false, purchaseOrderRecurrent: true}));
        purchaseOrders[0].sendEmailToApprover = true;
        purchaseOrders[0].recurrence = purchaseOrders.length;
        return bluebird.map(purchaseOrders, (pOrder) => {
            return this.httpClient.post(this.endPoint, _.cloneDeep(pOrder));
        }, {
            concurrency: 20
        });
    }

    async recurrenceApproval(purchaseOrderIds: string[], manager: any) {
        let recurrence = purchaseOrderIds.length;
        return bluebird.map(purchaseOrderIds, (pOrderId: string) => {
            recurrence--
            if (recurrence === 0) Object.assign(manager, {recurrenceDone: true});
            return this.httpClient.post(`${this.endPoint}/${pOrderId}/approval`, manager);
        }, {
            concurrency: 20
        });
    }

    async recurrenceUpdate(purchaseOrders: PurchaseOrder[]) {
        return bluebird.map(purchaseOrders, (pOrder: PurchaseOrder) => {
            return this.httpClient.update(this.endPoint, pOrder._id, pOrder);
        }, {
            concurrency: 20
        });
    }

    async update(purchaseOrder: PurchaseOrder) {
        return await this.httpClient.update(this.endPoint, purchaseOrder._id, purchaseOrder);
    }

    async approval(purchaseOrderId: String, manager: any) {
        return await this.httpClient.post(`${this.endPoint}/${purchaseOrderId}/approval`, manager);
    }

    async cancel(purchaseOrderId: String, purchaseOrder: PurchaseOrder) {
        return await this.httpClient.post(`${this.endPoint}/${purchaseOrderId}/cancel`, purchaseOrder);
    }

    async getPurchaseOrderHierarchy(usernameManager: String) {
        const queryManager = `manager=${usernameManager}`;
        return await this.httpClient.get(`${this.endPoint}/hierarchy?${queryManager}`);
    }

    async savePurchaseOrderHierarchy(purchaseOrderHierarchy: any) {
        return await this.httpClient.post(`${this.endPoint}/hierarchy`, purchaseOrderHierarchy);
    }

    async getSapDocEntryHasInvoice(sapDocEntry: String) {
        return await this.httpClient.get(`${this.endPoint}/sap/${sapDocEntry}/invoice`);
    }

    async getPurchaseOrderByAnticipationCode(anticipationCode: string): Promise<PurchaseOrder[]> {
        const purchaseOrders = new Array<PurchaseOrder>();
        var responsePurchaseOrders = await this.httpClient.get(`${this.endPoint}/anticipation/${anticipationCode}`);
        for (let order of responsePurchaseOrders) {
            let newPurchaseOrder = new PurchaseOrder();
            newPurchaseOrder.loadFromServer(order);
            purchaseOrders.push(newPurchaseOrder);
        }
        return purchaseOrders;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/purchaseOrder.service.ts